import React from "react";
import styled from "@emotion/styled";
import NessieButton from "../Button";
import { DojoTextFontFamily } from "./Typography";

type StyledButtonProps = {
  kind?: "primary" | "secondary" | "tertiary";
};

const StyledButton = styled(NessieButton)<StyledButtonProps>`
  display: flex;
  justify-content: center;
  gap: 12px;
  align-items: center;
  width: fit-content;
  height: 64px;
  border-radius: 32px;
  padding: 12px 28px;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 600;
  font-family: ${DojoTextFontFamily};
  ${(p) =>
    p.kind === "primary" &&
    `
      background-color: #884DFF;
      border: none;
      :hover {
        background-color: #6835D6;
      }
  `}
  ${(p) =>
    p.kind === "secondary" &&
    `
      background-color: #D3D7EC;
      color: #1A192D;
      border: none;
      :hover {
        background-color: #AAB0D8;
      }
  `}
  ${(p) =>
    p.kind === "tertiary" &&
    `
      background-color: white;
      color: #884DFF;
      :hover {
        background-color: #F5EBFF;
        border-color: #F5EBFF;
      }
  `}
`;

type ButtonProps = {
  noIcon?: boolean;
  kind?: "primary" | "secondary" | "tertiary";
  [key: string]: any;
};

export const Button: React.FC<ButtonProps> = (props) => {
  return (
    <StyledButton {...props}>
      {props.children}
      {!props.noIcon && (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
          <path
            d="M5.03674 22.7088C4.68674 23.3338 4.92678 24.1238 5.57678 24.4438C6.18678 24.7438 6.92177 24.4488 7.25677 23.8588C8.06677 22.4288 8.93174 21.2988 9.79174 20.4138C10.0167 20.1788 10.1668 19.8788 10.2118 19.5538C10.2518 19.2588 10.3068 18.9638 10.3818 18.6688C10.5568 18.0138 10.8118 17.3688 11.1468 16.7338C11.2668 16.5088 11.0167 16.2638 10.7967 16.3988C8.58675 17.7738 6.59674 19.9238 5.03674 22.7088Z"
            fill="white"
          />
          <path
            d="M26.2618 7.3438L19.4918 5.1988C18.7618 4.9638 17.9668 5.44881 17.8718 6.25381C17.8018 6.85381 18.2068 7.4138 18.7818 7.5938L21.6668 8.50881C22.0968 8.64381 22.1368 9.2388 21.7318 9.4338C16.2868 12.0688 12.8268 15.3838 11.8968 18.9138C11.3518 20.9738 11.7518 22.9938 13.0218 24.6038C14.1918 26.0888 15.9368 26.8688 17.6968 26.8688C18.4168 26.8688 19.1368 26.7338 19.8218 26.4738C19.8368 26.4688 19.8568 26.4588 19.8718 26.4538C20.0218 26.3938 20.1718 26.3288 20.3168 26.2588C20.3468 26.2438 20.3818 26.2288 20.4118 26.2138C20.5468 26.1438 20.6768 26.0688 20.8018 25.9938C20.8368 25.9738 20.8718 25.9538 20.9118 25.9288C21.0718 25.8288 21.2268 25.7188 21.3768 25.5988C23.9218 23.5888 24.3718 19.8488 22.3768 17.2588C21.8368 16.5588 21.1368 15.9838 20.3318 15.5538C20.1718 15.4688 19.9718 15.4838 19.8218 15.5838C19.2718 15.9488 18.7918 16.2988 18.3768 16.6388C18.0768 16.8838 18.1618 17.3638 18.5268 17.4938C19.2968 17.7638 19.9468 18.2038 20.3968 18.7838C21.5618 20.2938 21.3068 22.4738 19.8318 23.6338C19.6918 23.7438 19.5418 23.8388 19.3918 23.9238C19.3668 23.9388 19.3468 23.9488 19.3218 23.9638C19.1718 24.0438 19.0118 24.1138 18.8518 24.1688C18.8318 24.1738 18.8118 24.1838 18.7968 24.1888C18.4468 24.3038 18.0818 24.3688 17.7118 24.3688C17.5718 24.3688 17.4368 24.3638 17.2968 24.3488C16.3818 24.2388 15.5668 23.7838 14.9968 23.0588C14.2018 22.0538 13.9768 20.8738 14.3268 19.5538C15.0918 16.6488 18.4018 13.7188 23.4968 11.3788C23.8518 11.2138 24.2468 11.5138 24.1968 11.8988L23.7368 15.4188C23.6468 16.1038 24.1318 16.7288 24.8168 16.8188C24.8718 16.8238 24.9268 16.8288 24.9818 16.8288C25.6018 16.8288 26.1368 16.3688 26.2218 15.7388L27.1418 8.69381C27.2018 8.09881 26.8368 7.5288 26.2618 7.3438Z"
            fill="white"
          />
        </svg>
      )}
    </StyledButton>
  );
};

Button.defaultProps = {
  kind: "primary",
};
